<div infiniteScroll [fromRoot]="true" [infiniteScrollContainer]="'mat-sidenav-content'" [infiniteScrollDistance]="2"
     (scrolled)="scrollReplyComments()">

  <!-- Begin Comment -->
  <div *ngIf="commentState.showCommentReply" class="tl-post-comments">
    <div class="d-flex justify-content-center">
      <button mat-button (click)="loadMoreReplyComments()" matTooltip="Load More"
              *ngIf="commentState?.replyPageInfo?.hasNextPage && !hideActionButtons">
        Load more
        <mat-icon>unfold_more</mat-icon>
      </button>
    </div>
    <reply-comment *ngFor="let commentReplyState of commentState.replyMessages" [replyCommentState]="commentReplyState"
                   (upVoteReply)="upVoteReplyComment(commentReplyState?.comment?.Id)"
                   (deleteActionReply)="deleteReplyComment(commentReplyState?.comment?.Id)"
                   (downVoteReply)="downVoteReplyComment(commentReplyState?.comment?.Id)" [currentUser]="currentUser">
    </reply-comment>
    <form *ngIf="commentState?.showCommentReply" [formGroup]="commentGroup" novalidate>
      <div class="d-flex justify-content comments-area">
        <div class="cp-mobile">
          <img [src]="currentUser?.profileData?.photoURL || './assets/images/profile.jpg'" alt="avatar"
               class="tl-profile-pc pr-cursor">
        </div>
        <div class="tl-full-width">
          <mat-form-field class="tl-full-width" appearance="standard">
            <mat-label>Add Comment</mat-label>

            <mat-post-input formControlName="comment" [outsideContent]="replyEmojiEvent"></mat-post-input>
            <div matSuffix class="d-flex justify-content-end">
              <button type="button" mat-icon-button matTooltip="Add GIF" #replyGifEmojiTrigger="matMenuTrigger"
                      [matMenuTriggerFor]="replyGiphyMenu">
                <mat-icon color="primary">gif</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Insert Emoji" [matMenuTriggerFor]="replyEmojiMenu">
                <mat-icon class="sun-yellow">insert_emoticon</mat-icon>
              </button>
            </div>
          </mat-form-field>

          <mat-menu #replyEmojiMenu="matMenu" xPosition="before">
            <emoji-mart class="emoji-mart" set="{{set}}" (emojiSelect)="addEmoji($event)" title="Pick an emoji">
            </emoji-mart>
          </mat-menu>

          <mat-menu #replyGiphyMenu="matMenu" xPosition="before">
            <anms-giphy (click)="$event.stopPropagation()" (selectedGiphy)="selectedGiphy($event)"></anms-giphy>
          </mat-menu>

          <div class="d-flex justify-content-between post-comment">
            <button mat-button (click)="hideReplyComments()" *ngIf="!hideActionButtons" class="text-muted"
                    matTooltip="Hide">
              Hide
              <mat-icon>expand_less</mat-icon>
            </button>
            <button mat-button color="primary" [disabled]="!commentGroup?.valid || currentUser?.handle === null"
                    (click)="createReplyComment()">
              Post
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!-- End Comment -->
</div>
